import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            padding: '0px',
            maxHeight: 'calc(100vh - 100px)',
            overflowY: 'auto',
            backgroundColor: '#f9f9f9',
            borderRadius: '10px',
        }}>
            {/* Header with back button */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '25px',
                position: 'sticky',
                top: '0',
                backgroundColor: '#f9f9f9',
                padding: '10px 0',
                zIndex: '1'
            }}>
                <button 
                    onClick={() => navigate(-1)}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background-color 0.2s ease'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <ArrowBackIcon style={{ 
                        fontSize: '24px', 
                        color: '#1a6363' 
                    }} />
                </button>
                <h4 style={{
                    margin: '0',
                    fontSize: '20px', 
                    color: '#1a6363',
                    fontWeight: '600',
                    flex: '1'
                }}>
                    Privacy Policy for NLCC
                </h4>
            </div>
            
            {/* Content sections */}
            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
                <h5 style={{
                    fontSize: '18px', 
                    margin: '15px 0',
                    color: '#1a6363',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '8px'
                }}>
                    Privacy Policy
                </h5>
                <p style={{
                    textAlign: 'justify',
                    lineHeight: '1.6',
                    color: '#555'
                }}>
                    {/* <strong>Last updated:</strong> February 06, 2025<br/><br/> */}
                    This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when
                    You use the Service and tells You about Your privacy rights and how the law protects You.<br/><br/>
                    We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of
                    information in accordance with this Privacy Policy.
                </p>
            </div>

           <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
                <h5 style={{
                    fontSize: '18px', 
                    margin: '15px 0',
                    color: '#1a6363',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '8px'
                }}>
                    Interpretation and Definitions
                </h5>
                
                <h6 style={{
                    fontSize: '16px', 
                    margin: '12px 0 8px',
                    color: '#1a6363'
                }}>
                    Interpretation
                </h6>
                <p style={{
                    textAlign: 'justify',
                    lineHeight: '1.6',
                    color: '#555'
                }}>
                    The words of which the initial letter is capitalized have meanings defined under the following conditions. The following
                    definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                </p>

                <h6 style={{
                    fontSize: '16px', 
                    margin: '12px 0 8px',
                    color: '#1a6363'
                }}>
                    Definitions
                </h6>
                <div style={{
                    textAlign: 'justify',
                    lineHeight: '1.6',
                    color: '#555'
                }}>
                    For the purposes of this Privacy Policy:<br/><br/>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control"
                        means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of
                        directors or other managing authority.
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Application</strong> refers to NLCC, the software program provided by the Company.
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to NLCC.
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Country</strong> refers to: Zimbabwe
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Service</strong> refers to the Application.
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to
                        third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on
                        behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the
                        Service is used.
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service
                        infrastructure itself (for example, the duration of a page visit).
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such
                        individual is accessing or using the Service, as applicable.
                    </div>
                </div>
            </div>

            {/* Example section - follow this pattern for remaining sections */}
            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
                <h5 style={{
                    fontSize: '18px', 
                    margin: '15px 0',
                    color: '#1a6363',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '8px'
                }}>
                    Collecting and Using Your Personal Data
                </h5>
                
                <h6 style={{
                    fontSize: '16px', 
                    margin: '12px 0 8px',
                    color: '#1a6363'
                }}>
                    Types of Data Collected
                </h6>
                
                <div style={{
                    textAlign: 'justify',
                    lineHeight: '1.6',
                    color: '#555'
                }}>
                    <strong>Personal Data</strong><br/>
                    While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to
                    contact or identify You. Personally identifiable information may include, but is not limited to:
                    <ul style={{paddingLeft: '20px', margin: '10px 0'}}>
                        <li>Email address</li>
                        <li>First name and last name</li>
                        <li>Phone number</li>
                        <li>Address, State, Province, ZIP/Postal code, City</li>
                    </ul>

                    <strong>Usage Data</strong><br/>
                    Usage Data is collected automatically when using the Service.<br/><br/>
                    Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type,
                    browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages,
                    unique device identifiers and other diagnostic data.<br/><br/>
                    When You access the Service by or through a mobile device, We may collect certain information automatically, including,
                    but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device,
                    Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic
                    data.<br/><br/>
                    We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by
                    or through a mobile device.
                </div>
            </div>

            {/* Contact Us section */}
            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
                <h5 style={{
                    fontSize: '18px', 
                    margin: '15px 0',
                    color: '#1a6363',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '8px'
                }}>
                    Contact Us
                </h5>
                <p style={{
                    textAlign: 'justify',
                    lineHeight: '1.6',
                    color: '#555'
                }}>
                    If you have any questions about this Privacy Policy, You can contact us:<br/>
                    By email: <a href="mailto:newlifecovenantchurch147@gmail.com" style={{color: '#1a6363', textDecoration: 'none'}}>
                        newlifecovenantchurch147@gmail.com
                    </a>
                </p>
            </div>

        </div>
    );
}

export default PrivacyPolicy;